// Every destination's registry, in the order of the left menu, then the paused modules (not in the menu; Settings ›
// Modules holds them). lib/nav.ts builds the menu, breadcrumbs, counts and TASK_HOMES from these, and modules/routes.tsx
// builds their routes. To change a destination's pages, edit its own file.
import type { ModuleDef } from "./types";
import { ask } from "./ask";
import { campaigns } from "./campaigns";
import { conversations } from "./conversations";
import { quotes } from "./quotes";
import { contacts } from "./contacts";
import { associations } from "./associations";
import { results } from "./results";
import { settings } from "./settings";
import { attract } from "./attract";
import { network } from "./network";
import { reconnect } from "./reconnect";

export const MODULE_DEFS: ModuleDef[] = [ask, campaigns, conversations, quotes, contacts, associations, results, settings, attract, network, reconnect];

export * from "./types";
